import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';
import SectionTitle from './shared-components/SectionTitle';

const ListMainDeal = ({ title, list, className }) => {
  const theme = useContext(ThemeContext);

  if (!list || list.length === 0) {
    return null;
  }

  return (
    <>
      <div className={classNames('specs', className)}>
        <SectionTitle title={title} />
        <ul className="specs__list">
          {list.map((item, index) => {
            return (
              <li
                className="specs__item"
                dangerouslySetInnerHTML={{ __html: item }}
                key={index}
              />
            );
          })}
        </ul>
      </div>
      <style jsx>{`
        .specs {
          margin-bottom: 20px;
        }
        .specs__list {
          list-style: none;
          padding-left: 16px;
        }
        .specs__item {
          position: relative;
          list-style: none;
        }
        .specs__item:before {
          position: absolute;
          display: inline-block;
          content: '';
          height: 6px;
          width: 6px;
          background-color: ${theme.colors.primary};
          border-radius: 50%;
          top: 0.5em;
          left: -16px;
        }
        :global(.specs a) {
          color: ${theme.colors.primary};
        }
      `}</style>
    </>
  );
};

ListMainDeal.propTypes = {
  className: PropTypes.string,
  list: PropTypes.array,
  title: PropTypes.string,
};

ListMainDeal.defaultProps = {
  className: '',
  list: null,
  title: '',
};

export default ListMainDeal;
